import React from "react";
import produce from "immer";
import { createUseStyles } from "react-jss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const useStyles = createUseStyles({
  buttons: {
    display: "flex",
    "flex-direction": "column",
    position: "absolute",
    left: 0,
    top: 3,
    "& button": {
      "background-color": "#252525",
      border: "none",
      cursor: "pointer",
      "border-radius": 3,
      color: "white",
      "margin-bottom": 3,
      padding: 3,
    },
  },
});

const ListButtons = ({ setConfig, list, index }) => {
  const classes = useStyles();

  const up = () =>
    setConfig(
      produce(draft => {
        if (index !== 0)
          draft.options[list].splice(
            index - 1,
            0,
            draft.options[list].splice(index, 1)[0],
          );
      }),
    );

  const down = () =>
    setConfig(
      produce(draft => {
        if (index < draft.options[list].length)
          draft.options[list].splice(
            index + 1,
            0,
            draft.options[list].splice(index, 1)[0],
          );
      }),
    );

  const remove = () =>
    setConfig(
      produce(draft => {
        draft.options[list].splice(index, 1);
      }),
    );

  return (
    <div className={classes.buttons}>
      <button onClick={up}>
        <FontAwesomeIcon icon={["fas", "caret-up"]} fixedWidth />
      </button>
      <button onClick={down}>
        <FontAwesomeIcon icon={["fas", "caret-down"]} fixedWidth />
      </button>
      <button onClick={remove}>
        <FontAwesomeIcon icon={["fas", "times"]} fixedWidth />
      </button>
    </div>
  );
};

export default ListButtons;
